import { ProductSwitcherProps } from '@pushpay/shell/lib/types/components/product-switcher/product-switcher';
import { ProductSwitcherRedirectValue } from '@pushpay/shell/lib/types/components/product-switcher/types';
import { ProductSwitcherViewModel } from '../loggedinweb-generated';

type UseProductSwitcherPropsArgs = ProductSwitcherViewModel & {
	hasMasAccess: boolean;
	isMasActive: boolean;
	organizationKey: string;
};

const PRODUCT_SWITCHER_QUERY_FORM = 'https://grow.pushpay.com/lp-dm-product-switcher.html?utm_medium=site&utm_source=pushpay&utm_content=dm-product-switcher&utm_campaign=product-switcher&utm_term=faith--all--all';

export function getProductSwitcherConfig({
	CcbTenantUrl,
	LaunchPadUrl,
	PushpayMarketingUrl,
	hasMasAccess,
	isMasActive,
	organizationKey,
}: UseProductSwitcherPropsArgs): ProductSwitcherProps {
	function buildRedirectUrl(value: ProductSwitcherRedirectValue) {
		const url = new URL(LaunchPadUrl);
		url.searchParams.set('redirect', encodeURIComponent(btoa(JSON.stringify(value))));
		return url.toString();
	}

	const getSharedProps = (label: string, description = 'Product description') => ({
		description,
		label,
		learnMoreLabel: `Learn about ${label}`,
		learnMoreUrl: PRODUCT_SWITCHER_QUERY_FORM,
	});

	function getChmsProps(): ProductSwitcherProps['chmsProps'] {
		const label = 'ChMS';
		const description = 'Seamless church management software that scales and grows with your church';
		if (CcbTenantUrl) {
			return {
				access: 'hasAccess',
				url: buildRedirectUrl({ product: 'ccb', tenantUrl: CcbTenantUrl }),
				...getSharedProps(label),
			};
		}
		return { access: 'organizationNoProduct', ...getSharedProps(label, description) };
	}

	function getAppStudioProps(): ProductSwitcherProps['appStudioProps'] {
		const label = 'App Studio';
		const description = 'Church apps designed to increase engagement and leadership in your community';
		if (!isMasActive) {
			return { access: 'organizationNoProduct', ...getSharedProps(label, description) };
		}
		if (!hasMasAccess) {
			return { access: 'noPermission', ...getSharedProps(label) };
		}
		return { access: 'hasAccess', url: buildRedirectUrl({ product: 'mas', organizationKey }), ...getSharedProps(label) };
	}

	return {
		title: 'Switch to',
		pushpayMarketing: { label: 'Pushpay.com', title: 'Pushpay website', url: PushpayMarketingUrl },
		givingProps: { access: 'current', ...getSharedProps('Giving') },
		chmsProps: getChmsProps(),
		appStudioProps: getAppStudioProps(),
		tooltips: {
			noPermission: `Your organization has this product, but you'll need to request access from your organization's admin.`,
			organizationNoProduct: `Sorry, your organization doesn't have access to this product. Contact our team to learn more.`,
		},
		buttonLabel: 'Switch product',
		noOrgAcessTitle: 'More tools for your organization:',
	};
}
